import React, { useEffect } from "react";
import FirebaseAnalytics from "../services/analytics.service";
import BillPaymentBills from "../views/bill-payment/bill-payment-bills";

export default function BillPaymentBillsUI(props) {
	
	useEffect(() => {
		FirebaseAnalytics.generic_event(13);
		FirebaseAnalytics.generic_event(14);
	}, [])

	return (
		<div>
            <BillPaymentBills {...props}/>
		</div>
	)
}